import * as React from "react";

import { assertNever } from "@impero-com/common/utils/obj";

import { RawMultiTimePicker } from "components/form/legacyFields/multiTimePicker";
import { RawMultiTimezoneSelect } from "components/form/legacyFields/multiTimezoneSelect";
import { Time } from "components/timePicker";

import * as theme from "./theme.css";

type DueTimeOrTimezoneChange =
    | { kind: "DUE_TIME"; value: Time }
    | { kind: "TIMEZONE"; value: string };

interface ReadOnlyProps {
    dueTimes: Array<Time>;
    timezones: Array<string>;
}

interface EditProps extends ReadOnlyProps {
    onChange: (change: DueTimeOrTimezoneChange) => void;
}

type MultiDueTimeAndTimezoneInputProps =
    | ({ type: "READ_ONLY" } & ReadOnlyProps)
    | ({ type: "EDIT" } & EditProps);

class MultiDueTimeAndTimezoneInput extends React.PureComponent<MultiDueTimeAndTimezoneInputProps> {
    render() {
        const { props } = this;
        switch (props.type) {
            case "READ_ONLY":
                return this.renderReadOnly(props);
            case "EDIT":
                return this.renderEdit(props);
            default:
                return assertNever(props);
        }
    }

    private renderReadOnly = (props: ReadOnlyProps): React.ReactNode => {
        const { dueTimes, timezones } = props;
        return (
            <>
                <RawMultiTimePicker
                    type="READ_ONLY"
                    name="dueTime"
                    values={dueTimes}
                />
                <RawMultiTimezoneSelect
                    type="READ_ONLY"
                    name="timezoneName"
                    values={timezones}
                    display={"Input"}
                    className={theme.timezoneSelect}
                />
            </>
        );
    };

    private renderEdit = (props: EditProps): React.ReactNode => {
        const { dueTimes, timezones, onChange } = props;

        const onChangeDueTime = (value: Time | undefined) => {
            if (value) {
                onChange({ kind: "DUE_TIME", value });
            }
        };
        const onChangeTimezone = (value: string) =>
            onChange({ kind: "TIMEZONE", value });

        return (
            <>
                <RawMultiTimePicker
                    type="EDIT"
                    name="dueTime"
                    values={dueTimes}
                    onChange={onChangeDueTime}
                />
                <RawMultiTimezoneSelect
                    type="EDIT"
                    name="timezoneName"
                    values={timezones}
                    onChange={onChangeTimezone}
                    className={theme.timezoneSelect}
                    showSearch={true}
                />
            </>
        );
    };
}

export { MultiDueTimeAndTimezoneInput };
export type { MultiDueTimeAndTimezoneInputProps, DueTimeOrTimezoneChange };
